<template>
  <footer data-color="clear" class="c-footer u-bg--brand-dark u-align-center js-header-panel">
    <div class="u-relative u-pad-y-xl u-pad-x-w1of12">
      <!--<router-link  to="/" class="c-footer__logo t-link u-inline-block u-marg-b-lg">
        <img src="../../assets/medias/images/elite-logo-2.png" class="c-loader-intro__logo__ribbon__AV" style="margin-left:-50px;">
      </router-link>-->
      <div class="u-relative u-marg-b-md">
        <a href="javascript:void(0);"  @click="scrollToTop"  class="c-footer__link c-footer__scrolltop t-link t-text--xxs t-text-ls--md u-absolute u-relative@sm u-pos-bl u-color--white u-uppercase">
          <span class="u-inline-block u-valign-middle">Top</span>
           <img src="../../assets/medias/images/icons/arrow-top-gray.svg" class="c-footer__scrolltop__icon t-icon--arrow-top-white u-inline-block u-valign-bottom">
         </a>
          <ul class="o-list--inline u-marg-t-md@sm u-block u-valign-bottom">
              <li class="o-list__item u-marg-r-mds u-fit-w@sm u-marg-r-0@sm u-marg-b-xs@sm"  v-for="(item, index)  in globalContent.nav.links">
                <router-link  :to="item.href" class="c-footer__link t-link t-text-ls--md  u-color--white"  active-class="is-active" exact>{{item.label}}</router-link>
              </li>
          </ul>
      </div>
      <div class="c-line c-line--x u-bg--white u-marg-b-md"></div>
      <div class="u-relative u-align-left u-align-center@sm">
          <div class="u-absolute u-relative@sm u-pos-tr">
              <router-link  to="/terms-and-conditions" class="t-link t-text--sm u-inline-block u-color--gray-white u-relative@sm u-marg-b-xs@sm"  active-class="is-active" exact></router-link>
            </div>
          <p class="u-marg-t-md@sm t-text--sm u-color--white t-text--roman-italic" v-html="copyright"></p>
      </div>
  </div>
  </footer>
</template>
<script>
import      AppScrollObject from     '../app-scroll-object/index.vue'
import      CoreAjaxForm from     '../core-ajax-form/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
var firstScrollTo = require('vue-scrollto');
//const firstScrollTo = scroller()

export default {
  props: {
                    debug: {
                        type: Boolean,
                        default: !1
                    },
                    adminContent: {
                        type: Object,
                        default: function() {}
                    },
                    globalContent: {
                        type: Object,
                        default: function() {}
                    },
                    newsletterShown: {
                        type: Boolean,
                        default: !1
                    }
                    ,
                    careersShown: {
                        type: Boolean,
                        default: !1
                    }
                },
                components: {
                    'app-scroll-object':AppScrollObject,
                    'core-ajax-form':CoreAjaxForm,
                    "app-sliced-text":AppSlicedText

                },
                computed:
                {
                    content: function() {
                        return this.adminContent.en["theme-general-settings"]
                    },
                    copyright: function() {
                        return this.content.footer_copyright_label.replace("<year>", (new Date).getFullYear())
                    }
                },
                mounted: function()
                {
                      this.eventHub.$on("footer:applyto", this.onApplyTo)
                },
                destroyed: function()
                {
                    this.eventHub.$off("footer:applyto", this.onApplyTo)
                },
                methods: {
                    scrollToTop: function() {
                        window.scrollTo(0, 0)
                    },
                    onApplyTo:function(t,p)
                    {
                        this.$el.querySelector("#jobanswer1").innerHTML="Job Title:",
                        this.$el.querySelector("#companswer1").innerHTML="Company:",
                        this.$el.querySelector("#jobanswerIn").value=t,
                        this.$el.querySelector("#companswerIn").value=p,
                        this.$el.querySelector("#jobanswer").innerHTML=t,
                        this.$el.querySelector("#companswer").innerHTML=p,
                        firstScrollTo.scrollTo("#careersection")
                      }
                }
}
</script>
<style  scoped>
</style>
